import React from 'react';
import Banner from '../Banner/Banner';
import Skills from '../Skills/Skills';
import Projects from '../Projects/Projects';
import About from '../About/About';
import Contact from '../Contact/Contact';
import useTitle from '../../Hooks/useTitle';
import HappyClients from '../HappyClients/HappyClients';

const Home = () => {
    useTitle("Home");
    return (
        <div>
            <Banner></Banner>
            <Skills></Skills>
            <Projects></Projects>
            <About></About>
            <HappyClients></HappyClients>
            <Contact></Contact>
        </div>
    );
};

export default Home;